import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';

import { Study, AddTransactionsPayload, Entity, Transaction } from '../models';
import { ListResponse, PagedResponse, ObjectResponse } from '../interfaces';

@Injectable()
export class StudiesService extends BaseService<Study> {
  private _studyHasTransactions = false;

  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  public getPrimaryEntities(filter?: string): Observable<ListResponse<Entity>> {
    const apiUrl = this.applyQueryString(filter, `${this.getResourceUrl()}primary-entities/`);

    return this.http.get<ListResponse<Entity>>(apiUrl);
  }

  public getTransactions(studyId: number, filter?: string): Observable<PagedResponse<Transaction>> {
    const apiUrl = this.applyQueryString(filter, `${this.getResourceUrl()}${studyId}/transactions/`);

    return this.http.get<any>(apiUrl);
  }

  public addTransactions(studyId: number, data: AddTransactionsPayload): Observable<ListResponse<Transaction>> {
    const apiUrl = `${this.getResourceUrl()}${studyId}/transactions/`;

    return this.http.put<ListResponse<Transaction>>(apiUrl, data);
  }

  public removeTransaction(studyId: number, transactionId: number): Observable<ObjectResponse<Transaction>> {
    const apiUrl = `${this.getResourceUrl()}${studyId}/transactions/${transactionId}`;

    return this.http.delete<ObjectResponse<Transaction>>(apiUrl);
  }

  public setStudyHasTransactions(status: boolean): void {
    this._studyHasTransactions = status;
  }

  public canCreatePbaWithinStudy(): boolean {
    return this._studyHasTransactions;
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}studies/`;
  }
}
